
import axiosDefault from "../../api";

export const getLegislativeStatus = async () => {
  const data = await axiosDefault.get('/list-legislative-status');
  return data;
}
